<template>
  <v-stepper :value="statuses.length - 1" vertical class="policyLifeCycle">
    <template v-for="(status, index) in statuses">
      <v-stepper-step :step="index" :complete="true" :key="index">
        {{claimStatusConst[status.statusCode]}}
      </v-stepper-step>
      <v-stepper-content :step="index" :key="status.statusDate">
        <div>
          <v-icon>mdi-account-edit</v-icon>
          <span>{{status.name}}</span>
        </div>
        <div>
          <v-icon>mdi-calendar-clock</v-icon>
          <span>{{formatDateTime(status.statusDate)}}</span>
        </div>
      </v-stepper-content>
    </template>
  </v-stepper>
</template>

<script>
import { formatDisplayDateTime } from '@/utils/date'
import { claimStatus } from '@/const/claims'

export default {
  computed: {
    statuses() {
      return this.$store.state.claims.claimDetail.commonInfo.statuses
    },
    claimStatusConst() {
      return claimStatus
    }
  },
  methods: {
    formatDateTime(date) {
      return formatDisplayDateTime(date)
    }
  }
}
</script>

<style lang="scss">

</style>
